import React, { ReactNode, useEffect, useState } from 'react'
import { Avatar } from 'antd'
import { UserOutlined } from '@ant-design/icons'
import { AvatarProps } from 'antd/lib/avatar/avatar'

import { getThumbUrl } from '../../../utils/image'

interface CustomProps {
	disableThumbnail?: boolean
}

const ProfileAvatar = (props: AvatarProps & CustomProps & React.RefAttributes<HTMLElement>) => {
	const { disableThumbnail, ...rest } = props
	const [src, setSrc] = useState<string | null | ReactNode>(
		disableThumbnail ? props.src : getThumbUrl(props.src as string)
	)

	useEffect(() => {
		setSrc(disableThumbnail ? props.src : getThumbUrl(props.src as string))
	}, [props.src])

	const addDefaultSrc = () => {
		const isEqual = src === props.src
		if (!isEqual && src !== '') {
			setSrc(props.src)
		} else if (src !== '') {
			setSrc('')
		}
		return true
	}

	return (
		<Avatar
			{...rest}
			src={src}
			style={props.src && src ? { ...props.style } : { ...props.style, backgroundColor: '#E1F0FA', color: '#96C6E4' }}
			icon={<UserOutlined className="default-avatar" />}
			alt="profile avatar"
			onError={addDefaultSrc}
		/>
	)
}

export default ProfileAvatar
